import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { BiTrackApi } from '@eureka/domains/src/bi-track/apis/bi-track-api';
import type { BiTrackParams } from '@eureka/domains/src/bi-track/types';
import { useBrowserFingerprint } from './use-browser-fingerprint';

export interface TrackOptions {
    eventType: string;
    sourceType?: string;
    otherParam?: string;
    eventDetail?: Record<string, unknown> | string;
    moduleType?: string;
}

export function useTrack() {
    const biTrackApi = injectService<BiTrackApi>(BiTrackApi);
    const { getFingerprint } = useBrowserFingerprint();

    const track = async(options: TrackOptions) => {
        // 处理 event_detail_str：支持 string 或 object
        let eventDetail: Record<string, any> = {}
        if (typeof options.eventDetail === 'string') {
            try {
                eventDetail = JSON.parse(options.eventDetail)
            } catch {
                eventDetail = { data: options.eventDetail }
            }
        } else if (options.eventDetail) {
            eventDetail = { ...options.eventDetail }
        }

        const fingerprint = await getFingerprint()

        if (!eventDetail.signatureId) {
            eventDetail.signatureId = fingerprint
        }

        if (!eventDetail.URL) {
            eventDetail.URL = window.location.href
        }

        const params: BiTrackParams = {
            event_type: options.eventType,
            source_type: options.sourceType,
            other_param: options.otherParam,
            event_detail_str: JSON.stringify(eventDetail),
            module_type: options.moduleType ?? 'LS',
        };

        biTrackApi.biTrack(params);
    };

    return track;
}
